import { jsx as _jsx } from "react/jsx-runtime";
var NotFound = function () {
    return _jsx("p", { className: "text-center w-100 textXL", children: "Page Not Found" });
};
export default NotFound;
